import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/lib/seo";
import { useContent } from "@/lib/content";
import Reveal from "@/components/Reveal";
import { formatDate } from "@/lib/format";

export default function Blog() {
  const { t } = useContent();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/posts")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO title="Nos conseils allaitement" description="Articles, conseils et rituels pour accompagner les mamans allaitantes à Dakar : démarrer l'allaitement, tire-lait, lactation, bien-être." />
      <section className="bg-rose/40 pt-36 pb-14 md:pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <p className="eyebrow mb-3">{t("blog.eyebrow")}</p>
            <h1 className="font-serif text-4xl md:text-6xl text-teal-dark">{t("blog.title")}</h1>
            <p className="mt-4 max-w-xl text-ink/70">
              {t("blog.sub")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {["a", "b", "c"].map((k) => <div key={`skeleton-${k}`} className="h-80 rounded-3xl bg-cream-light animate-pulse" />)}
            </div>
          ) : posts.length === 0 ? (
            <p className="text-center text-ink/60 py-16">{t("blog.empty")}</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
              {posts.map((post, i) => (
                <Reveal key={post.id} delay={i * 0.08}>
                  <Link data-testid={`blog-post-${post.slug}`} to={`/conseils/${post.slug}`} className="group block bg-white rounded-3xl border border-line overflow-hidden hover:shadow-[0_20px_60px_rgba(16,114,105,0.12)] hover:-translate-y-1 transition-all duration-500">
                    <div className="overflow-hidden">
                      {post.cover && <img src={post.cover} alt={post.title} loading="lazy" className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105" />}
                    </div>
                    <div className="p-6">
                      <p className="font-mono text-[11px] uppercase tracking-widest text-mauve">{formatDate(post.created_at)}</p>
                      <h2 className="mt-2 font-serif text-xl md:text-2xl text-teal-dark leading-snug group-hover:text-teal transition-colors">{post.title}</h2>
                      <p className="mt-3 text-sm text-ink/70 line-clamp-3">{post.excerpt}</p>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
